module.exports = __webpack_public_path__ + "img/icon_ping_map.ecc8b95.png";